module.exports = "/_next/static/images/8c98ba909841333e92969becf58bedf4-Nubank_HickDuarte_58654 (2) 1_lg.jpg.webp";